module.exports = __webpack_public_path__ + "static/media/banner.cbd6e284.png";